/**
 * DemoBanner — shown when the current session is a demo account.
 * Reads ml_demo flag from localStorage (set during demo login).
 * Displayed above BillingBanner in SidebarLayout.
 */

export function DemoBanner() {
  const isDemo = localStorage.getItem("ml_demo") === "true"
  if (!isDemo) return null

  return (
    <div
      className="flex items-center justify-between px-4 py-2 text-sm bg-blue-600 text-white"
      style={{ flexShrink: 0 }}
    >
      <span>
        You are exploring a demo account.{" "}
        <a href="/signup" className="underline font-medium">
          Sign up free
        </a>{" "}
        to save your work.
      </span>
    </div>
  )
}
